import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import LogoBasico from "../../assets/icons/LogoBasico"
import "./Topbar.scss";
import { amplify } from "../../service/api/AuthService";
import useUser from "../../pages/Login/useUser";
import { Link } from "react-router-dom";
import { IconChevronDown, IconKey, IconLogout } from "@tabler/icons";


const Topbar = (props) => {
  const { history } = props;
  const [achronym, setAchronym] = useState("");
  const {
    user: { userName },
  } = useUser();



  useEffect(() => {
    if (userName != null) {
      const nameSplitted = userName && userName.split(" ");
      if (nameSplitted.length > 1) {
        setAchronym(nameSplitted[0].charAt(0) + nameSplitted[1].charAt(0))
      } else {
        setAchronym(nameSplitted[0].charAt(0) + nameSplitted[0].charAt(1))
      }
    }
  }, [userName]);

  const handleClickSignOut = () => {
    amplify.signOut();
  };

  const handleChangePassword = () => {
    return history.push({
      pathname: "/change-password",
    });
  };



  return (
    <>
      <div
        className="main d-flex d-inline justify-content-between"
      >
        <div className="logo">
          <Link to="/score">
            <LogoBasico width={124} heigth={24} fill={"#5c157d"} />
          </Link>
        </div>
        <div className="d-flex flex-row">
          <div
            className="me-2"
            id="user-acronym-circle"
          >
            <div className="acronym">{achronym}</div>
          </div>
          <div className="user text-start pt-1 ps-2">
            <div className="username">
              {userName}
            </div>
          </div>
          <div className="dropdown">
            <button
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
            >
              <div>
                <IconChevronDown className="IconChevronDown"/>
              </div>

            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <label
                  onClick={handleChangePassword}
                  id="item"
                  className="dropdown-item text-end"
                >
                  <div className="d-flex">
                    <div className="link-icon">
                      <IconKey />
                    </div>
                    <div className="text-secondary">
                      Cambio de contraseña
                    </div>
                  </div>
                </label>
              </li>
              <li>
                <label
                  onClick={handleClickSignOut}
                  id="item"
                  className="dropdown-item text-end"
                >
                  <div className="d-flex">
                    <div className="link-icon">
                      <IconLogout />
                    </div>
                    <div className="text-secondary">
                      Cerrar sesión
                    </div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Topbar);
